// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e09940f3","239":"dc3335d2","732":"4e20534e"}[chunkId] + ".chunk.js";
};